export const DEFAULT_PARAMS = {
	monthlyDeposit: 50_000,
	focusOn: false,
};

export const CONFIG = { MIN_MONTHLY_SAVINGS: 10_000, MAX_MONTHLY_SAVINGS: 100_000, MAX_RESULTS: 3 };

export const BASIC_SEARCH_FIELDS = ["monthlyDeposit", "interestedInMortgage", "notMakeUseOfConnectedProduct"];

export const EXAMPLE_CALCULATIONS = [
	{
		monthlyDeposit: 10_000,
		totalPayment: 1_200_000,
		totalInterestWithBonus: 367_820,
		totalSavings: 1_567_820,
	},
	{
		monthlyDeposit: 20_000,
		totalPayment: 2_400_000,
		totalInterestWithBonus: 735_630,
		totalSavings: 3_135_630,
	},
	{
		monthlyDeposit: 30_000,
		totalPayment: 3_600_000,
		totalInterestWithBonus: 1_103_462,
		totalSavings: 4_703_462,
	},
	{
		monthlyDeposit: 40_000,
		totalPayment: 4_800_000,
		totalInterestWithBonus: 1_471_274,
		totalSavings: 6_271_274,
	},
	{
		monthlyDeposit: 50_000,
		totalPayment: 6_000_000,
		totalInterestWithBonus: 1_839_106,
		totalSavings: 7_839_106,
	},
	{
		monthlyDeposit: 60_000,
		totalPayment: 7_200_000,
		totalInterestWithBonus: 2_206_926,
		totalSavings: 9_406_926,
	},
	{
		monthlyDeposit: 70_000,
		totalPayment: 8_400_000,
		totalInterestWithBonus: 2_574_736,
		totalSavings: 10_974_736,
	},
	{
		monthlyDeposit: 80_000,
		totalPayment: 9_600_000,
		totalInterestWithBonus: 2_942_668,
		totalSavings: 12_542_668,
	},
	{
		monthlyDeposit: 90_000,
		totalPayment: 10_800_000,
		totalInterestWithBonus: 3_310_380,
		totalSavings: 14_110_380,
	},
	{
		monthlyDeposit: 100_000,
		totalPayment: 12_000_000,
		totalInterestWithBonus: 3_678_212,
		totalSavings: 15_678_212,
	},
];
